import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 4.5C7.86 4.5 4.5 7.86 4.5 12C4.5 16.14 7.86 19.5 12 19.5C16.14 19.5 19.5 16.14 19.5 12C19.5 7.86 16.14 4.5 12 4.5ZM10.6928 15.5572C10.5863 15.6637 10.4137 15.6637 10.3072 15.5572L7.27912 12.5291C6.98689 12.2369 6.98689 11.7631 7.27912 11.4709C7.57105 11.1789 8.04427 11.1786 8.33662 11.4701L10.5 13.6275C10.5 13.6275 15.3662 8.76129 15.66 8.4675C15.9538 8.17371 16.4304 8.17456 16.7231 8.46938C17.0144 8.76274 17.0136 9.23643 16.7212 9.52875L10.6928 15.5572Z",
		fill: "#002A2A"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 18.75C15.7279 18.75 18.75 15.7279 18.75 12C18.75 8.27208 15.7279 5.25 12 5.25C8.27208 5.25 5.25 8.27208 5.25 12C5.25 15.7279 8.27208 18.75 12 18.75ZM12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
		fill: "#002A2A"
	})]
});
export { SvgRadioSelected as ReactComponent };
